import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import homeImage from "../assets/img/HomePage/homeImage.svg";
import playStore from "../assets/img/HomePage/googlePlay.svg";
import appStore from "../assets/img/HomePage/appStore.svg";
import UNTF from "../assets/img/HomePage/UNTF.svg";
import lums from "../assets/img/HomePage/LUMS1.svg";
import shirkatGah from "../assets/img/HomePage/shirkat.svg";
import emergency from "../assets/img/HomePage/emergency.svg";
import referral from "../assets/img/HomePage/referral.svg";
import guidance from "../assets/img/HomePage/guidance.svg";
import laws from "../assets/img/HomePage/laws.svg";
import minority from "../assets/img/HomePage/minority.svg";
import acid from "../assets/img/HomePage/acid.svg";
import marriage from "../assets/img/HomePage/marriageLaws.svg";
import assault from "../assets/img/HomePage/assault.svg";
import childLaws from "../assets/img/HomePage/childLaws.svg";
import cyberCrime from "../assets/img/HomePage/cyberCrime.svg";
import aboveFooter from "../assets/img/HomePage/aboveFooter.svg";
import webApp from "../assets/img/HomePage/webApp.svg";
import Footer from "../components/Footer";
import Modal from "../components/Modal";
import HomePopUp from "../components/HomePopUp";
import modalTab1 from "../assets/img/HomePage/modalTab1.svg";
import modalTab2 from "../assets/img/HomePage/modalTab2.svg";
import modalTab3 from "../assets/img/HomePage/modalTab3.svg";
import EmergencyServices from "./EmergencyServices";
import ReferralDirectory from "./ReferralDirectory";
import ReferralDirectoryEntitiesGrid from "./ReferralDirectoryEntitiesGrid";
import Helplines from "./Helplines";
import HelplineDetails from "./HelplineDetails";
import RelevantLaws from "./RelevantLaws";
import ServicesDetail from "./ServicesDetail";
import GuideStep from "./GuideStep";
import About from "./About";
import Settings from "./Settings";
import Contact from "./Contact";
import ContactInfo from "./ContactInfo";
import GlobalSearch from "./GlobalSearch";
import { makeStyles } from "@mui/styles";
import { Dialog, Slide, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { changeTab } from "../redux/TabSlice";
import EntitiesGrid from "./EntitiesGrid";
import { getLanguage, setLanguageId } from "../redux/LanguageSlice";
import { getProvince, setProvinceId } from "../redux/ProvinceSlice";
import {
  getDistrict,
  setDistrictId,
  setProvDistrict,
} from "../redux/DistrictSlice";
import { getAppContent } from "../redux/AppContentSlice";
import { getInitialData } from "../redux/InitialDataSlice";
import { getTitleFromAppContent } from "../helpers/utils";
import clsx from "clsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  bgcolor: {
    background: "#FFFFFF",
  },
  textColor: {
    color: theme.palette.primary.main,
  },
  texthome: {
    color: theme.palette.secondary.main,
  },
  texthomeBlack: {
    color: "#000000",
  },

  sectionbg: {
    background: theme.palette.primary.main,
  },
  emergencyBg: {
    backgroundColor: theme.palette.emergency.light,
  },

  emergencyTextBg: {
    backgroundColor: theme.palette.emergency.main,
  },
  referralBg: {
    backgroundColor: "#A94E76", // Light purple-pink for image area (matches Picture1)
  },

  referralTextBg: {
    backgroundColor: "#8E264E", // Dark purple-pink for text area (matches Picture1)
  },
  guidanceBg: {
    backgroundColor: theme.palette.guidance.light,
  },

  guidanceTextBg: {
    backgroundColor: theme.palette.guidance.main,
  },
  lawsBg: {
    backgroundColor: theme.palette.laws.light,
  },

  lawsTextBg: {
    backgroundColor: theme.palette.laws.main,
  },
  sectionBgLight: {
    backgroundColor: "#F6F1F4",
  },
  videoContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
      justifyContent: "center",
    },
  },
  frame: {
    width: "100%",
    maxWidth: "280px",
    height: "160px",
    marginTop: "10px",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "400px",
      height: "225px",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "500px",
      height: "280px",
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "560px",
      height: "315px",
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: "640px",
      height: "360px",
    },
  },
  // Stable container for Dialog content to prevent blink on tab switch
  dialogContent: {
    minHeight: "70vh",
    backgroundColor: "#F6F1F4",
    overflow: "auto",
  },
  "@keyframes dialogContentFadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  dialogContentFade: {
    animation: "$dialogContentFadeIn 0.12s ease-out",
  },
}));

const HomePage = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { language, selLanguageId } = useSelector((state) => state.language);
  const { district } = useSelector((state) => state.district);
  const { appContent } = useSelector((state) => state.appContent);
  const { province } = useSelector((state) => state.province);
  const [openLanguage, setOpenLanguage] = React.useState(false);
  const [openProvince, setOpenProvince] = React.useState(false);
  const [openDistrict, setOpenDistrict] = React.useState(false);
  const [nationalTitle, setNationalTitle] = useState("");
  const [provincialTitle, setProvincialTitle] = useState("");
  const [serviceTitle, setServiceTitle] = useState("");
  const [guidanceTitle, setGuidanceTitle] = useState("");
  const [lawsTitle, setLawsTitle] = useState("");
  const [referralTitle, setReferralTitle] = useState("");
  const [emergencyTitle, setEmergencyTitle] = useState("");
  const { tab } = useSelector((state) => state.tab);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  // Fetch all initial data in one call for better performance
  useEffect(() => {
    dispatch(getInitialData());
    dispatch(getLanguage()); // Also call this to ensure language is set
  }, [dispatch]);

  // When language changes, translate the data
  useEffect(() => {
    if (selLanguageId) {
      dispatch(getDistrict({ selLanguageId }));
      dispatch(getProvince({ selLanguageId }));
      dispatch(getAppContent({ selLanguageId }));
    }
  }, [dispatch, selLanguageId]);

  const handleOpen = () => {
    if (selLanguageId) setOpen(true);
    else setOpenLanguage(true);
  };

  const onClose = () => {
    setOpenLanguage(false);
    setOpenProvince(false);
    setOpenDistrict(false);
    dispatch(setLanguageId(""));
    dispatch(setDistrictId(""));
    dispatch(setProvinceId(""));
    dispatch(setProvDistrict(""));
  };

  const handleClose = () => {
    if (openLanguage) {
      setOpenLanguage(false);
      setOpenProvince(true);
    } else if (openProvince) {
      setOpenProvince(false);
      setOpenDistrict(true);
    } else {
      setOpenDistrict(false);
      setOpen(true);
    }
  };

  const handleClickClose = () => {
    dispatch(changeTab("HumQadam"));
    setOpen(false);
  };

  useEffect(() => {
    if (appContent) {
      setGuidanceTitle(getTitleFromAppContent(appContent, "Step by Step Guidance"));
      setLawsTitle(getTitleFromAppContent(appContent, "Relevant Laws"));
      setNationalTitle(getTitleFromAppContent(appContent, "National Helplines"));
      setProvincialTitle(getTitleFromAppContent(appContent, "Provincial Helplines"));
      setServiceTitle(getTitleFromAppContent(appContent, "Service Providers"));
      setEmergencyTitle(getTitleFromAppContent(appContent, "Emergency Services"));
      setReferralTitle(getTitleFromAppContent(appContent, "Support Providing Organizations") || getTitleFromAppContent(appContent, "Referral") || getTitleFromAppContent(appContent, "Referral Guide"));
    }
  }, [appContent]);

  const componentToRender = () => {
    switch (tab) {
      case "HumQadam":
        return <HomePopUp onClose={handleClickClose} />;
      case "Home":
        return <HomePopUp onClose={handleClickClose} />;
      case "EmergencyServices":
        return <EmergencyServices />;
      case "PoliceServices":
        return <ServicesDetail />;
      case "MedicalServices":
        return <ServicesDetail />;
      case "Laws":
        return (
          <EntitiesGrid
            bgColor="#BCACE3"
            bgTextColor={theme.palette.laws.main}
            textDark="#271258"
            img={laws}
            page="Laws"
            title={lawsTitle}
            nextPage="RelevantLaws"
          />
        );
      case "StepGuide":
        return (
          <EntitiesGrid
            bgColor="#EFF2DC"
            bgTextColor={theme.palette.guidance.main}
            img={guidance}
            page="StepGuide"
            title={guidanceTitle}
            nextPage="GuideStep"
          />
        );
      case "RelevantLaws":
        return <RelevantLaws />;
      case "GuideStep":
        return <GuideStep />;
      case "Settings":
        return <Settings />;
      case "Contact":
        return <Contact />;
      case "ContactInfo":
        return <ContactInfo />;
      case "Feedback":
        return <Contact />;
      case "ReferralDirectoryEntitiesGrid":
        return <ReferralDirectoryEntitiesGrid />;
      case "ReferralDirectory":
        return <ReferralDirectory />;
      case "Provincial Helplines":
        return <Helplines title={provincialTitle} />;
      case "National Helplines":
        return <Helplines title={nationalTitle} />;
      case "Service Providers":
        return <Helplines title={serviceTitle} />;
      case "HelplineDetails":
        return <HelplineDetails />;
      case "GlobalSearch":
        return <GlobalSearch />;
      case "About":
      case "Partners":
      case "Privacy":
      case "Terms":
        return <About />;
      default:
        return <HomePopUp onClose={handleClickClose} />;
    }
  };

  const images = [
    {
      id: 3,
      image: shirkatGah,
    },
    {
      id: 1,
      image: UNTF,
    },
    {
      id: 2,
      image: lums,
    },
  ];
  return (
    <div>
      <Header main={true} />
      <section className={`${classes.bgcolor}`}>
        <div className="container mx-auto">
          <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-12 lg:py-16 lg:grid-cols-12 place-content-center">
            <div className="mr-auto place-self-center lg:col-span-8">
              <h1
                className={`max-w-2xl mb-4 text-2xl font-extrabold tracking-tight leading-none md:text-2xl xl:text-3xl ${classes.texthome} px-4`}
              >
                A Gender-Based Violence <br></br>(GBV) response application
              </h1>
              <div
                className={` ${classes.texthomeBlack} px-4`}
              >
                <p>
                  {getTitleFromAppContent(appContent, "About Humqadam Paragraph 1", selLanguageId) ||
                    "Humqadam is an initiative of Shirkat Gah – Women's Resource Centre, supported by the UN Trust Fund to End Violence against Women, providing survivor-centred access to GBV services."}
                </p>
                <p className="mt-4">
                  {getTitleFromAppContent(appContent, "About Humqadam Paragraph 2", selLanguageId) ||
                    "This App offers emergency contacts, referral directories, guidance on responding to GBV, and relevant laws. Available in English and Urdu, the app works offline and can be downloaded from the Google Play Store or App Store or by scanning the QR code."}
                </p>
              </div>
              <div className="flex md:hidden flex-row items-center px-4 mt-4">
                <a
                  className="inline-flex self-center items-center mr-2 justify-center py-3 "
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.shirkatgah.humqadam"
                >
                  <img
                    src={playStore}
                    alt="Playstore"
                    className="w-28 object-contain text-base font-medium text-center"
                  />
                </a>
                <a
                  className="inline-flex self-center items-center justify-center ml-2 mr-2 py-3 "
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/pk/app/humqadam/id6463237568"
                >
                  <img
                    src={appStore}
                    alt="Appstore"
                    className="inline-flex w-24 object-contain text-base font-medium text-center"
                  />
                </a>
                <button
                  onClick={handleOpen}
                  className="inline-flex cursor-pointer w-28 items-center justify-center ml-2 py-3"
                >
                  <img src={webApp} alt="Web App" className="w-full object-contain" />
                </button>
              </div>
            </div>
            <div className="hidden object-contain lg:mt-0 lg:col-span-4 lg:flex lg:flex-col lg:items-center lg:mt-6">
              <img src={homeImage} alt="mockup" />
              <div className="hidden lg:flex flex-row mt-6 space-x-4">
                <a
                  className="inline-flex self-center items-center mr-1 justify-center py-3 "
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.shirkatgah.humqadam"
                >
                  <img
                    src={playStore}
                    alt="Playstore"
                    className="w-32 object-contain text-base font-medium text-center"
                  />
                </a>
                <a
                  className="inline-flex self-center items-center justify-center ml-2 mr-3  py-3 "
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/pk/app/humqadam/id6463237568"
                >
                  <img
                    src={appStore}
                    alt="Appstore"
                    className="inline-flex w-28 object-contain text-base font-medium text-center"
                  />
                </a>
                <button onClick={handleOpen} className="inline-flex cursor-pointer w-28 items-center justify-center py-3">
                  <img src={webApp} alt="Web App" className="w-full object-contain" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex px-4 justify-center flex-col sm:flex-row items-center gap-2 sm:gap-6">
          {images.map((img) => (
            <div key={img.id} className="flex-shrink-0">
              <img
                src={img.image}
                alt="partners"
                className="inline-flex items-center justify-center px-2 py-2 h-20 w-32 sm:h-24 sm:w-36 md:h-28 md:w-40 object-contain"
              />
            </div>
          ))}
        </div>
        <div className={`mt-6 ${classes.sectionbg}`}>
          <div className={clsx("mx-auto container p-4 sm:p-6 lg:p-8 overflow-hidden", classes.videoContainer)}>
            <div className="flex justify-center w-full min-w-0 lg:w-auto">
              <iframe
                className={clsx(classes.frame)}
                src="https://www.youtube.com/embed/knG_6S1ucCc?si=llAsKGmkQlglVA34"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            <div className="flex justify-center w-full min-w-0 lg:w-auto">
              <iframe
                className={clsx(classes.frame)}
                src="https://www.youtube.com/embed/AdkmuTgOMk8?si=1jt2D4JOLE0scYTR"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
        <div className={`${classes.sectionBgLight}`}>
          <div className="container flex flex-col md:flex-row p-12 items-center mx-auto">
            <div
              className={`md:rounded-l-2xl rounded-none ${classes.sectionbg} p-5 text-white w-full h-full lg:h-64 lg:w-7/12`}
            >
              <h1 className=" font-bold text-lg">
                A Gender-Based Violence(GBV) Response Services Application
              </h1>
              <br></br>
              <h2 className="text-lg">
                Humqadam is a result of a collective effort for designing an
                application that can help Women Human Rights Defenders (and
                general public) of Pakistan to respond to cases of gender based
                violence. The app provides quick access to referral services,
                relevant laws and a navigation guide for dealing with specific
                issues of violence.
              </h2>
            </div>
            <div
              className={`${classes.bgcolor} rounded-none md:rounded-3xl md:shadow py-10 px-5 w-full lg:w-5/12`}
            >
              <div className="flex flex-col sm:flex-row justify-center items-center">
                <div
                  className={`m-2 w-36 flex-col ${classes.emergencyBg} rounded-xl`}
                >
                  <div>
                    <img
                      src={emergency}
                      alt="Appstore"
                      className="px-3 py-5 w-20 mx-auto"
                    />
                  </div>
                  <p
                    className={`${classes.emergencyTextBg} text-center rounded-b-xl p-2 text-xs text-white`}
                  >
                    {emergencyTitle || "Emergency Services"}
                  </p>
                </div>
                <div
                  className={`m-2 w-36 flex-col ${classes.referralBg} rounded-xl`}
                >
                  <div>
                    <img
                      src={referral}
                      alt="Appstore"
                      className="px-3 py-5 w-20 mx-auto"
                    />
                  </div>
                  <p
                    className={`${classes.referralTextBg} text-center rounded-b-xl p-2 text-xs text-white`}
                  >
                    {referralTitle || "Support Providing Organizations"}
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row justify-center items-center">
                <div
                  className={`m-2 w-36 flex-col ${classes.guidanceBg} rounded-xl`}
                >
                  <div>
                    <img
                      src={guidance}
                      alt="Appstore"
                      className="px-3 py-5 h-24 mx-auto"
                    />
                  </div>
                  <p
                    className={`${classes.guidanceTextBg} text-center rounded-b-xl py-2 text-xs text-white`}
                  >
                    {guidanceTitle || "Step by Step Guidance"}
                  </p>
                </div>
                <div
                  className={`m-2 w-36 flex-col ${classes.lawsBg} rounded-xl`}
                >
                  <div>
                    <img
                      src={laws}
                      alt="Appstore"
                      className="px-3 py-5 h-24 mx-auto"
                    />
                  </div>
                  <p
                    className={`${classes.lawsTextBg} text-center rounded-b-xl p-2 text-xs text-white`}
                  >
                    {lawsTitle || "Relevant Laws"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex pb-10 items-center justify-center">
            <button
              onClick={handleOpen}
              className={`${classes.sectionbg} shadow-lg shadow-pink-900 px-7 p-3 text-white font-bold text-lg rounded-xl`}
            >
              {getTitleFromAppContent(appContent, "Get Started") || "Get Started!"}
            </button>
          </div>
        </div>
        <div className="mx-auto container p-10">
          <h2 className={`text-center font-bold text-lg ${classes.textColor}`}>
            Major Laws/Themes of HumQadam
          </h2>
          <div className="p-3 flex flex-col md:flex-row justify-evenly items-center">
            <div className="w-full md:w-1/4">
              <img
                src={acid}
                alt="Appstore"
                className="px-3 py-5 h-24 w-20 mx-auto"
              />
              <p
                className={`text-center rounded-b-xl p-2 text-xs font-bold ${classes.textColor}`}
              >
                ACID CRIMES
              </p>
            </div>
            <div className="w-full md:w-1/4">
              <img
                src={childLaws}
                alt="Appstore"
                className="px-3 py-5 h-24 w-20 mx-auto"
              />
              <p
                className={`text-center rounded-b-xl p-2 text-xs font-bold ${classes.textColor}`}
              >
                LAWS REGARDING CHILDREN<br></br>(CHILD ABUSE, CHILD CUSTODY)
              </p>
            </div>
            <div className="w-full md:w-1/4">
              <img
                src={assault}
                alt="Appstore"
                className="px-3 py-5 h-24 w-20 mx-auto"
              />
              <p
                className={`text-center rounded-b-xl p-2 text-xs font-bold ${classes.textColor}`}
              >
                ASSAULT<br></br>(SEXUAL ASSAULT, BATTERY ETC)
              </p>
            </div>
          </div>
          <div className="p-3 flex flex-col md:flex-row justify-evenly items-center">
            <div className="w-full md:w-1/4">
              <img
                src={marriage}
                alt="Appstore"
                className="px-3 py-5 h-24 w-20 mx-auto"
              />
              <p
                className={`text-center rounded-b-xl p-2 text-xs font-bold ${classes.textColor}`}
              >
                MARRIAGE LAWS <br></br>(EARLY AGE MARRIAGE, FORCE MARRIAGE,
                DESIRE TO TERMINATE)
              </p>
            </div>
            <div className="w-full md:w-1/4">
              <img
                src={minority}
                alt="Appstore"
                className="px-3 py-5 h-24 w-20 mx-auto"
              />
              <p
                className={`text-center rounded-b-xl p-2 text-xs font-bold ${classes.textColor}`}
              >
                MINORITY RIGHTS
              </p>
            </div>
            <div className="w-full md:w-1/4">
              <img
                src={cyberCrime}
                alt="Appstore"
                className="px-3 py-5 h-24 w-20 mx-auto"
              />
              <p
                className={`text-center rounded-b-xl p-2 text-xs font-bold ${classes.textColor}`}
              >
                CYBER CRIMES
              </p>
            </div>
          </div>
        </div>
        <div className={classes.sectionbg}>
          <div className="flex items-center justify-center mx-auto container p-8 sm:p-12 md:p-16 lg:p-20">
            <img src={aboveFooter} alt="Appstore" className="max-w-full h-auto" />
          </div>
        </div>
        <Footer />
      </section>
      <Modal
        open={openLanguage}
        handleClose={handleClose}
        onClose={onClose}
        head="Choose Your Language"
        data={language}
        img={modalTab1}
        isImage={true}
        type="language"
      />
      <Modal
        open={openProvince}
        handleClose={handleClose}
        onClose={onClose}
        head="Choose Your Province"
        data={province}
        img={modalTab2}
        isImage={false}
        type="province"
      />
      <Modal
        open={openDistrict}
        handleClose={handleClose}
        onClose={onClose}
        head="Choose Your District"
        data={district}
        img={modalTab3}
        isImage={false}
        type="district"
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClickClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: { backgroundColor: "#F6F1F4" },
        }}
      >
        <div
          className={`${classes.dialogContent} ${classes.dialogContentFade}`}
          key={tab}
        >
          {componentToRender()}
        </div>
      </Dialog>
    </div>
  );
};

export default HomePage;
